(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hsa-b2b-product-guide"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = () => {
    document.querySelectorAll('[data-hsa-b2b-guide], [data-hsa-led-guide]').forEach((root) => {
      if (root.dataset.hsaAccordionReady === 'real-accordion-v3') return;
      const nav = root.querySelector('[data-guide-nav], .hsa-led-guide__rail nav');
      if (!nav) return;
      const pairs = Array.from(nav.querySelectorAll('a[href^="#"]'))
        .map((link) => {
          const href = link.getAttribute('href');
          const panel = href ? document.getElementById(href.slice(1)) : null;
          return panel && root.contains(panel) ? { link, panel } : null;
        })
        .filter(Boolean);
      if (!pairs.length) return;

      const groupName = pairs[0].panel.id + '-accordion';
      const isStandalone = (panel) => /(?:^|-)(?:gallery|faq|faqs|chat|support)(?:-|$)/i.test(panel.id);
      let activeStandalone = null;

      pairs.forEach((item, index) => {
        const { link, panel } = item;
        item.standalone = isStandalone(panel);
        if (item.standalone) {
          panel.classList.add('hsa-guide-standalone');
          link.setAttribute('aria-controls', panel.id);
          link.removeAttribute('aria-expanded');
          item.accordion = null;
          return;
        }
        let accordion = panel.closest('details.hsa-guide-accordion__item');
        if (!accordion || !root.contains(accordion)) {
          accordion = document.createElement('details');
          accordion.className = 'hsa-guide-accordion__item';
          const summary = document.createElement('summary');
          summary.className = 'hsa-guide-accordion__summary';
          summary.textContent = link.textContent.trim();
          panel.parentNode.insertBefore(accordion, panel);
          accordion.appendChild(summary);
          accordion.appendChild(panel);
          const heading = panel.querySelector(':scope > h2');
          if (heading) heading.classList.add('hsa-guide-accordion__original-heading');
        }
        accordion.setAttribute('name', groupName);
        accordion.id = accordion.id || panel.id + '-accordion';
        accordion.open = index === 0;
        item.accordion = accordion;
        link.setAttribute('aria-controls', accordion.id);
      });

      const syncLinks = () => {
        const expanded = pairs.find((item) => item.accordion && item.accordion.open);
        const selected = activeStandalone || expanded;
        pairs.forEach(({ link, accordion }) => {
          if (accordion) link.setAttribute('aria-expanded', String(accordion.open));
          else link.removeAttribute('aria-expanded');
          if (selected && link === selected.link) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        });
      };

      pairs.forEach((item) => {
        if (!item.accordion) return;
        item.accordion.addEventListener('toggle', () => {
          if (item.accordion.open) {
            activeStandalone = null;
            pairs.forEach(({accordion}) => {
              if (accordion && accordion !== item.accordion) accordion.open = false;
            });
          }
          syncLinks();
        });
      });

      nav.addEventListener('click', (event) => {
        const link = event.target.closest('a[href^="#"]');
        if (!link || !nav.contains(link)) return;
        const item = pairs.find((entry) => entry.link === link);
        if (!item) return;
        event.preventDefault();

        if (item.standalone) {
          activeStandalone = item;
          pairs.forEach(({accordion}) => { if (accordion) accordion.open = false; });
          syncLinks();
          window.requestAnimationFrame(() => {
            item.panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
          });
          return;
        }

        activeStandalone = null;
        const shouldOpen = !item.accordion.open;
        pairs.forEach(({accordion}) => { if (accordion) accordion.open = false; });
        if (shouldOpen) {
          item.accordion.open = true;
          window.requestAnimationFrame(() => {
            item.accordion.scrollIntoView({ behavior: 'smooth', block: 'start' });
          });
        }
        syncLinks();
      });

      nav.addEventListener('keydown', (event) => {
        if (event.key !== ' ' && event.key !== 'Spacebar') return;
        const link = event.target.closest('a[href^="#"]');
        if (link && nav.contains(link)) { event.preventDefault(); link.click(); }
      });

      const openShopifyInbox = (attempt = 0) => {
        const chat = document.querySelector('shopify-chat');
        const activator = chat?.shadowRoot?.querySelector('[part="activator"]');
        if (activator) { activator.click(); return; }
        if (attempt < 20) window.setTimeout(() => openShopifyInbox(attempt + 1), 100);
      };
      root.querySelectorAll('[data-shopify-inbox-open]').forEach((button) => {
        button.addEventListener('click', () => openShopifyInbox());
      });

      syncLinks();
      root.dataset.hsaAccordionReady = 'real-accordion-v3';
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hsa-channel-letter-guide"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = () => {
    document.querySelectorAll('[data-hsa-channel-guide]').forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';

      const openShopifyInbox = (attempt = 0) => {
        const host =
          document.getElementById('ShopifyChat') ||
          document.querySelector('inbox-online-store-chat');

        const toggle =
          host?.shadowRoot?.querySelector('button.chat-toggle') ||
          host?.shadowRoot?.querySelector('.chat-app > button');

        if (toggle) {
          toggle.click();
          return;
        }

        if (attempt < 12) {
          window.setTimeout(() => openShopifyInbox(attempt + 1), 250);
        }
      };

      root.querySelectorAll('[data-shopify-inbox-open]').forEach((button) => {
        button.addEventListener('click', () => openShopifyInbox());
      });

      const links = Array.from(root.querySelectorAll('[data-guide-nav] a'));
      const sections = links
        .map((link) => document.querySelector(link.getAttribute('href')))
        .filter(Boolean);

      links.forEach((link) => {
        link.addEventListener('click', (event) => {
          const target = document.querySelector(link.getAttribute('href'));
          if (!target) return;

          event.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          history.replaceState(null, '', link.getAttribute('href'));
        });
      });

      if (!('IntersectionObserver' in window)) return;

      const observer = new IntersectionObserver(
        (entries) => {
          const activeEntry = entries
            .filter((entry) => entry.isIntersecting)
            .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];

          if (!activeEntry) return;

          links.forEach((link) => link.removeAttribute('aria-current'));
          const activeLink = links.find((link) => link.getAttribute('href') === '#' + activeEntry.target.id);
          if (activeLink) activeLink.setAttribute('aria-current', 'true');
        },
        { rootMargin: '-18% 0px -65% 0px', threshold: [0.01, 0.2, 0.5] }
      );

      sections.forEach((section) => observer.observe(section));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
